var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.$route.name === 'projectSettingsProjects')?_c('ProjectsTable'):(_vm.$route.name === 'projectSettingsProjectsCreate')?_c('ProjectsCreate'):(_vm.$route.name.includes('projectSettingsProjectsDetails'))?_c('ProjectsDetails'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }